import { Box, BoxProps, Paper, styled } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import {
  StyledTextOrTranslation,
  StyledTextOrTranslationProps,
  TextOrTranslationProps
} from '.'

const InfoBoxPaper = styled(Paper)(({ theme }) => {
  const { border, fontStyle, text } = theme.variables.colors.infoBox
  return {
    border: `1px solid ${border}`,
    fontStyle: fontStyle,
    color: text
  }
})

const StyledInfoBox = styled((props: BoxProps) => <Box {...props} />)(() => ({
  whiteSpace: 'pre-line'
}))

export interface InfoBoxProps extends TextOrTranslationProps {
  styledEndPartProps?: StyledTextOrTranslationProps
}

export const InfoBox = ({ styledEndPartProps, ...rest }: InfoBoxProps) => {
  return (
    <InfoBoxPaper elevation={0} square>
      <Box display="flex" flexDirection="row" p={1}>
        <Box pr={1}>
          <HelpOutlineIcon />
        </Box>
        <StyledInfoBox alignSelf="center">
          <StyledTextOrTranslation {...rest} />
          <StyledTextOrTranslation {...styledEndPartProps} />
        </StyledInfoBox>
      </Box>
    </InfoBoxPaper>
  )
}
